import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { func, object } from 'prop-types'

import Input from '@taglivros/oef_componentes/build/components/input'
import Select from '@taglivros/oef_componentes/build/components/select'
import Button from '@taglivros/oef_componentes/build/components/button'

import { camposDadosPessoais } from '../constantsPerfil'
import { REQUIRED_MESSAGE } from '../../../constants'
import { empty, isEmptyObject, capitalizeStrings, retornarChaveObjeto, sanitizeValue } from '../../../utils/helpers/helpers'
import { tagTheme } from '@taglivros/tag-components'

const WrapperFormDadosPessoais = styled.div`
  margin-top: 20px;

  & > div {
    position: relative;
    z-index: 1;
  }

  .form__row {
    margin-bottom: 20px;
  }

  select#sexo {
    margin: 0 0 20px 0;
    color: ${tagTheme.cores.cinza500}
  }
`

const FormDadosPessoais = ( { dadosAssociado, onConfirmar } ) => {
  const [ state, setState ] = useState( {} )
  const [ erros, setErros ] = useState( {} )
  const [ sucesso, setSucesso ] = useState( {} )
  const [ camposObrigatoriosPreenchidos, setCamposObrigatoriosPreenchidos ] = useState( false )
  const camposObrigatorios = Object.keys( camposDadosPessoais ).filter( campo => camposDadosPessoais[ campo ].obrigatorio )

  useEffect(
    () => {
      const dadosAssociadoFormatados = Object.entries( dadosAssociado ).reduce(
        ( acumulador, dado ) => {
          const [ chave, valor ] = dado
          if ( retornarChaveObjeto( camposDadosPessoais ).includes( chave ) ) {
            return {
              ...acumulador,
              [ chave ]: camposDadosPessoais[ chave ].formatador ? camposDadosPessoais[ chave ].formatador( valor ) : valor
            }
          }

          return acumulador
        },
        {}
      )

      if ( !isEmptyObject( dadosAssociado ) ) {
        const sucessos = Object.entries( dadosAssociadoFormatados ).reduce(
          ( acumulador, dado ) => {
            const [ chave, valor ] = dado
            if ( !empty( valor ) ) {
              return {
                ...acumulador,
                [ chave ]: true
              }
            }

            return {
              ...acumulador,
              [ chave ]: false
            }
          },
          {}
        )

        setState( dadosAssociadoFormatados )
        setErros( {} )
        setSucesso( sucessos )
      }
    },
    [ dadosAssociado ]
  )

  useEffect(
    () => {
      const camposObrigatoriosComSucesso = Object.keys( sucesso ).every( suc => sucesso[ suc ] )
      if ( !isEmptyObject( state ) && camposObrigatoriosComSucesso ) {
        const hasPreenchimento = camposObrigatorios.reduce(
          ( acumulador, campoObrigatorio ) => {
            return !empty( state[ campoObrigatorio ] ) && acumulador
          },
          true
        )

        setCamposObrigatoriosPreenchidos( hasPreenchimento )
      }
    },
    [ state, sucesso ]
  )

  const validate = ( event, isOnSubmit=false ) => {
    const { name, value } = event.target
    let validacaoErros = {}

    if ( value === '' && !isOnSubmit ) {
      validacaoErros = {
        ...erros,
        [ name ]: REQUIRED_MESSAGE
      }
    } else if ( !camposObrigatoriosPreenchidos || isOnSubmit ) {
      const obrigatoriosNaoPreenchidos = camposObrigatorios.reduce(
        ( acumulador, obrigatorio ) => {
          if ( empty( state[ obrigatorio ] ) ) {
            return {
              ...acumulador,
              [ obrigatorio ]: REQUIRED_MESSAGE
            }
          }

          return acumulador
        },
        {}
      )

      validacaoErros = { ...erros, ...obrigatoriosNaoPreenchidos }
    }

    Object.entries( camposDadosPessoais ).forEach( campo => {
      const [ chave ] = campo

      if ( chave === name && camposDadosPessoais[ chave ].validador ) {
        validacaoErros = { ...erros, [ chave ]: camposDadosPessoais[ chave ].validador( value ) }
      }
    } )

    setSucesso( {
      ...sucesso,
      [ name ]: empty( validacaoErros[ name ] ) && !empty( state[ name ] )
    } )

    setErros( validacaoErros )
  }

  const handleChange = event => {
    if ( event.codigo ) {
      setErros( {
        ...erros,
        'sexo': null
      } )

      setSucesso( {
        ...sucesso,
        'sexo': true
      } )

      setState( {
        ...state,
        'sexo': event.codigo
      } )
    }

    if ( event.target ) {
      const { name, value } = event.target
      let valorFormatado = null

      setErros( {
        ...erros,
        [ name ]: null
      } )

      setSucesso( {
        ...sucesso,
        [ name ]: null
      } )

      Object.entries( camposDadosPessoais ).forEach( campo => {
        const [ chave ] = campo

        if ( chave === name ) {
          valorFormatado = camposDadosPessoais[ chave ].formatador ? camposDadosPessoais[ chave ].formatador( sanitizeValue( value ) ) : value
        }
      } )

      if ( name === 'nome' ) {
        valorFormatado = capitalizeStrings( value )
      }

      setState( {
        ...state,
        [ name ]: valorFormatado
      } )
    }
  }

  const handleBlur = event => {
    validate( event )
  }

  const handleSubmit = event => {
    event.preventDefault()
    validate(
      event,
      true
    )
    if ( onConfirmar ) {
      onConfirmar( { ...dadosAssociado, ...state } )
    }
  }

  return (
    <form onSubmit={ handleSubmit }>
      <WrapperFormDadosPessoais>
        { Object.entries( camposDadosPessoais ).map( campo => {
          const [ chave, objeto ] = campo
          return (
            <div
              className={ `form__row form__${chave}` }
              key={ chave }
            >
              { objeto.tipoInput === Select && (
                <Select
                  defaultOption={ objeto.itens.find( ( { 'value': pronoun } ) => pronoun === state[ chave ] ) }
                  erro={ erros[ chave ] }
                  itens={ objeto.itens }
                  label={ objeto.label }
                  name={ chave }
                  onBlur={ handleBlur }
                  onChange={ handleChange }
                  onPressEnter={ handleSubmit }
                  required={ objeto.obrigatorio }
                  sucesso={ sucesso[ chave ] }
                />
              )}

              { objeto.tipoInput !== Select && (
                <Input
                  erro={ erros[ chave ] }
                  label={ objeto.label }
                  maxLength={ objeto.maxLength }
                  name={ chave }
                  onBlur={ handleBlur }
                  onChange={ handleChange }
                  onKeyPress={ objeto.handleKeyPress }
                  onPressEnter={ handleSubmit }
                  sucesso={ sucesso[ chave ] }
                  tipo={ objeto.tipoInput }
                  value={ state[ chave ] }
                />
              )}

            </div>
          )
        } ) }

        <Button
          disabled={ !camposObrigatoriosPreenchidos }
          type={ Button.TYPE_SUBMIT }
        >
          Confirmar
        </Button>
      </WrapperFormDadosPessoais>
    </form>
  )
}

FormDadosPessoais.propTypes = {
  'dadosAssociado': object.isRequired,
  'onConfirmar': func.isRequired
}

export default FormDadosPessoais
